
export function triggerDownload(url: string, filename?: string): void {
    const a = document.createElement('a');
    a.href = url;
    if (filename) {
        a.download = filename;
    }
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

export function isAudioFile(file: File): boolean {
    return file.type.startsWith('audio/') ||
        file.name.endsWith('.mp3') ||
        file.name.endsWith('.wav') ||
        file.name.endsWith('.ogg') ||
        file.name.endsWith('.flac');
}

export function stripFileExtension(filename: string): string {
    const lastDotIndex = filename.lastIndexOf('.');
    if (lastDotIndex === -1) {
        return filename;
    }
    return filename.substring(0, lastDotIndex);
}

export function downloadTextFile(content: string, filename: string): void {
    const extension = filename.split('.').pop();
    const mimeTypes: Record<string, string> = {
        'vtt': 'text/vtt',
        'srt': 'application/x-subrip',
        'ass': 'text/x-ass',
        'txt': 'text/plain',
        'json': 'application/json',
    };
    const mimeType = mimeTypes[extension || ''] || 'text/plain';
    const blob = new Blob([content], {type: mimeType});
    const url = URL.createObjectURL(blob);
    triggerDownload(url, filename);
    URL.revokeObjectURL(url);
}

export function sanitizeFilename(filename: string) {
    return filename.replace(/[^a-zA-Z0-9-_.]/g, '');
}

export function combineArrayBuffers(buffers: ArrayBuffer[]): ArrayBuffer {
    const totalLength = buffers.reduce((acc, value) => acc + value.byteLength, 0);
    const combinedBuffer = new ArrayBuffer(totalLength);
    let currentOffset = 0;
    const combinedView = new Uint8Array(combinedBuffer);
    buffers.forEach(buffer => {
        const view = new Uint8Array(buffer);
        combinedView.set(view, currentOffset);
        currentOffset += buffer.byteLength;
    });
    return combinedBuffer;
}

export async function getMediaDuration(file: File): Promise<number | undefined> {
    return new Promise((resolve) => {
        const video = document.createElement('video');
        const objectUrl = URL.createObjectURL(file);

        const cleanup = () => {
            URL.revokeObjectURL(objectUrl);
            video.src = '';
        };

        video.onloadedmetadata = () => {
            const duration = video.duration;
            cleanup();
            resolve(isFinite(duration) ? duration : undefined);
        };

        video.onerror = () => {
            cleanup();
            resolve(undefined);
        };

        video.src = objectUrl;
    });
}
